<template>
  <ul class="menuList">
    <li v-for="(menu, i) in menus" :key="i">
      <router-link :to="{name: menu.route}" @click.native="toggleSpSlide()">{{menu.label}}</router-link>          
    </li>
  </ul>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'McolMenu',
  props: ['menus'],
  methods: {
    ...mapActions([
      "toggleSpSlide"
    ])  
  }  
}
</script>

<style lang="scss" scope>
.menuList{
  li{
    border-bottom: 1px solid #EEE;
    a{
      padding: 16px 24px;
      display: flex;
      color: #0b7a29;
      text-decoration: none;
    }
  }
}
</style>

